import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { marked } from 'marked';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Select, Input, Checkbox, Label, Duration, Currency, RadioButtons, Radio, RadioButtonsItem, Slider } from '@/components/FormElements';
import Notice from '@/components/Notice';
import Tooltip from '@/components/Tooltip';
import templateEngine from '@/utils/templateEngine';
import parseUserAnswer from '@/utils/reporting/parseUserAnswer';
import { durationNumberToString } from '@/utils/time';
import { getEditingAreaAttr, getEditingAreaMetaDataAttr } from '@/components/Editor/hooks/useEditingAreas';
import OptionsMenu from './OptionsMenu';
import useOptions from './useOptions';
import useSubscribeValidation from './useSubscribeValidation';
import useSubscribeEvents from './useSubscribeEvents';
import useBroadcastEvents from './useBroadcastEvents';
import getDefaultValue from './getDefaultValue';
import Loading from './Loading';
import styles from './styles.module.scss';
import sliderStyles from '@/components/FormElements/Slider/styles.module.scss';
import 'rc-slider/assets/index.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0Z",
      fill: "#D8DAE6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5Z",
      fill: "#696C80"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V10Z",
      fill: "#696C80"
    })]
  }));
};

InfoIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const Question = _ref => {
  let {
    data,
    editing = false,
    formElement,
    onChange,
    disabled,
    triggerValidation,
    triggerChange
  } = _ref;
  const {
    id,
    layout,
    name,
    placeholder,
    minimumValue,
    maximumValue,
    minimumValueWarning,
    step,
    heading,
    options: srcOptions,
    defaultValue: srcDefaultValue,
    defaultChecked,
    valueType,
    tooltip,
    required
  } = data;
  const {
    isValid
  } = useSubscribeValidation(id);
  const isRequired = Boolean(required);
  const hasMinimumValueWarning = Boolean(minimumValueWarning);
  const {
    0: isDirty,
    1: setIsDirty
  } = useState(false);
  const {
    broadcastChange
  } = useBroadcastEvents(data);
  const hasConfiguredDefaultValue = typeof srcDefaultValue !== 'undefined';
  const defaultValue = getDefaultValue({
    srcDefaultValue,
    valueType,
    minimumValue,
    maximumValue
  });
  const labelDataset = useMemo(() => !editing ? null : {
    [getEditingAreaAttr()]: id,
    [getEditingAreaMetaDataAttr()]: JSON.stringify({
      selection: data.selections || 'missing',
      selectionIndex: 0
    })
  }, [editing, data.selections, id]);
  const minMaxAttrs = {};
  const stepAttrs = {};
  if (typeof minimumValue === 'number') minMaxAttrs.min = minimumValue;
  if (typeof maximumValue === 'number') minMaxAttrs.max = maximumValue;
  if (typeof step === 'number') stepAttrs.step = step;
  const {
    0: value,
    1: setValue
  } = useState(defaultValue);
  const formInput = useRef(null);
  const {
    options,
    onSurrogateChange
  } = useOptions({
    srcOptions,
    question: data
  }); // Subscribe to broadcasted
  // events for the question

  useSubscribeEvents(data, formElement, setValue); // Trigger render of form field
  // for default value updates

  const {
    0: defaultValueKey,
    1: setdefaultValueKey
  } = useState(`${defaultValue}`);
  useEffect(() => {
    !isDirty && setdefaultValueKey(`${defaultValue}`);
  }, [isDirty, defaultValue]); // Ensure that value is synced from
  // admin updates for inputs using `value`

  useEffect(() => {
    const isNotUsingDefaultValue = ['slider', 'money', 'duration'].includes(layout);

    if (!isDirty && isNotUsingDefaultValue) {
      setValue(defaultValue);
    }
  }, [layout, isDirty, defaultValue]); // Update isDirty and input value

  const onChangeValue = srcValue => {
    const newValue = parseUserAnswer(data, srcValue);
    setValue(newValue);
    setIsDirty(true);
    broadcastChange(newValue);
    onChange && onChange(data, newValue);
  }; // Parse a value into the configured template


  const valueFormatter = val => {
    const template = data.template || '{{value}}';
    return marked.parseInline(templateEngine(template, {
      value: val
    }));
  };

  if (!data.selections) {
    return /*#__PURE__*/_jsx(Loading, _objectSpread({
      className: styles.formField,
      layout: layout
    }, labelDataset && {
      dataset: labelDataset
    }));
  } // Money input


  if (layout === 'money') {
    // Show warning when input is dirty
    // and the value is less than the minimum
    const showWarning = isDirty && hasMinimumValueWarning && Number(value) < (minimumValue || 0);
    const enableFloating = valueType === 'floatingPoint' || typeof step === 'number' && step < 1;
    return /*#__PURE__*/_jsx(Label, _objectSpread(_objectSpread(_objectSpread({
      text: heading,
      forInput: id,
      className: styles.formField
    }, labelDataset && {
      dataset: labelDataset
    }), tooltip && {
      icon: /*#__PURE__*/_jsx(TooltipIcon, {
        tooltip: tooltip
      })
    }), {}, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(OptionsMenu, {
          options: options,
          question: data,
          forInput: id,
          disabled: Boolean(disabled),
          onChange: (val, inputEl) => onSurrogateChange(inputEl, val),
          children: /*#__PURE__*/_jsx(Currency, _objectSpread(_objectSpread({
            id: id,
            hasError: isValid ? false : true,
            allowNegativeValue: false,
            allowDecimals: enableFloating,
            placeholder: placeholder || '',
            value: value,
            onKeyUp: triggerValidation,
            onChange: val => onChangeValue(val),
            name: name || id,
            required: isRequired
          }, minMaxAttrs), stepAttrs), `${id}-${defaultValueKey}`)
        }), showWarning && /*#__PURE__*/_jsx(Notice, {
          text: minimumValueWarning,
          type: "warning"
        })]
      })
    }));
  } // Regular number input


  if (layout === 'number') {
    // Show warning when input is dirty
    // and the value is less than the minimum
    const showWarning = isDirty && hasMinimumValueWarning && Number(value) < (minimumValue || 0);
    return /*#__PURE__*/_jsx(Label, _objectSpread(_objectSpread(_objectSpread({
      text: heading,
      forInput: id,
      className: styles.formField
    }, labelDataset && {
      dataset: labelDataset
    }), tooltip && {
      icon: /*#__PURE__*/_jsx(TooltipIcon, {
        tooltip: tooltip
      })
    }), {}, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(OptionsMenu, {
          options: options,
          question: data,
          forInput: id,
          disabled: Boolean(disabled),
          onChange: (val, inputEl) => onSurrogateChange(inputEl, val),
          children: /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({
            id: id,
            type: "number",
            placeholder: placeholder || '',
            defaultValue: defaultValue,
            hasError: isValid ? false : true,
            onChange: evt => onChangeValue(`${evt.target.value}`.trim() || '0'),
            name: name || id,
            required: isRequired
          }, minMaxAttrs), stepAttrs), `${id}-${defaultValueKey}`)
        }), showWarning && /*#__PURE__*/_jsx(Notice, {
          text: minimumValueWarning,
          type: "warning"
        })]
      })
    }));
  } // Regular text input


  if (valueType === 'string' && layout === 'text') {
    return /*#__PURE__*/_jsx(Label, _objectSpread(_objectSpread(_objectSpread({
      text: heading,
      forInput: id,
      className: styles.formField
    }, labelDataset && {
      dataset: labelDataset
    }), tooltip && {
      icon: /*#__PURE__*/_jsx(TooltipIcon, {
        tooltip: tooltip
      })
    }), {}, {
      children: /*#__PURE__*/_jsx(OptionsMenu, {
        options: options,
        question: data,
        forInput: id,
        disabled: Boolean(disabled),
        onChange: (val, inputEl) => onSurrogateChange(inputEl, val),
        children: /*#__PURE__*/_jsx(Input, {
          id: id,
          placeholder: placeholder || '',
          defaultValue: `${defaultValue}`,
          onChange: evt => onChangeValue(evt.target.value),
          required: isRequired,
          name: name || id,
          hasError: isValid ? false : true
        }, `${id}-${defaultValueKey}`)
      })
    }));
  } // Select Menu


  if (layout === 'select') {
    return /*#__PURE__*/_jsx(Label, _objectSpread(_objectSpread(_objectSpread({
      text: heading,
      forInput: id,
      className: styles.formField
    }, labelDataset && {
      dataset: labelDataset
    }), tooltip && {
      icon: /*#__PURE__*/_jsx(TooltipIcon, {
        tooltip: tooltip
      })
    }), {}, {
      children: /*#__PURE__*/_jsx(Select, {
        id: id,
        hasError: isValid ? false : true,
        defaultValue: typeof defaultValue === 'boolean' ? `${defaultValue}` : defaultValue,
        name: name || id,
        disabled: options.length === 0,
        onChange: evt => onChangeValue(evt.target.value),
        children: options.map(option => /*#__PURE__*/_jsx("option", {
          value: option.value,
          children: option.content
        }, `${id}-options-${option.value}`))
      }, `${id}-${defaultValueKey}`)
    }));
  }

  if (layout === 'checkbox') {
    return /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({
      id: id,
      className: styles.formField,
      checked: Boolean(defaultChecked),
      disabled: Boolean(disabled),
      name: name || id
    }, labelDataset && {
      dataset: labelDataset
    }), {}, {
      onChange: evt => onChangeValue(`${evt.target.checked}`),
      children: heading || tooltip ? /*#__PURE__*/_jsx(Label, _objectSpread({
        text: heading,
        forInput: id
      }, tooltip && {
        icon: /*#__PURE__*/_jsx(TooltipIcon, {
          tooltip: tooltip
        })
      })) : /*#__PURE__*/_jsx(_Fragment, {})
    }), `${id}-${defaultValueKey}`);
  }

  if (layout === 'slider') {
    return /*#__PURE__*/_jsxs(Label, _objectSpread(_objectSpread(_objectSpread({
      text: heading,
      className: styles.formField
    }, labelDataset && {
      dataset: labelDataset
    }), tooltip && {
      icon: /*#__PURE__*/_jsx(TooltipIcon, {
        tooltip: tooltip
      })
    }), {}, {
      children: [/*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread({
        className: sliderStyles.container,
        marks: {
          [minMaxAttrs.min]: valueFormatter(minMaxAttrs.min),
          [minMaxAttrs.max]: valueFormatter(minMaxAttrs.max)
        },
        tipProps: {
          overlayClassName: sliderStyles.tooltip
        },
        tipFormatter: val => valueFormatter(val),
        defaultValue: defaultValue,
        onAfterChange: val => {
          const updatedVal = Array.isArray(val) ? val[0] : val;
          onChangeValue(updatedVal);
          onSurrogateChange(formInput, updatedVal);
        }
      }, minMaxAttrs), stepAttrs), `${id}-${defaultValueKey}`), /*#__PURE__*/_jsx("input", {
        ref: formInput,
        id: id,
        className: styles['-hide'],
        type: "number",
        name: name || id,
        value: Number(value),
        readOnly: true
      })]
    }));
  } // 24 Hour Duration


  if (layout === 'duration') {
    return /*#__PURE__*/_jsx(Label, _objectSpread(_objectSpread(_objectSpread({
      text: heading,
      forInput: id,
      className: styles.formField
    }, labelDataset && {
      dataset: labelDataset
    }), tooltip && {
      icon: /*#__PURE__*/_jsx(TooltipIcon, {
        tooltip: tooltip
      })
    }), {}, {
      children: /*#__PURE__*/_jsx(OptionsMenu, {
        options: options,
        question: data,
        forInput: id,
        parseSelectedValue: val => durationNumberToString(parseFloat(val)),
        disabled: Boolean(disabled),
        onChange: (val
        /*, inputEl*/
        ) => {
          onChangeValue(val);
          setTimeout(() => triggerChange());
        },
        children: /*#__PURE__*/_jsx(Duration, _objectSpread({
          id: id,
          hasError: isValid ? false : true,
          placeholder: placeholder || '',
          value: hasConfiguredDefaultValue || isDirty ? value : undefined,
          onKeyUp: triggerValidation,
          onChange: val => onChangeValue(val),
          required: isRequired
        }, minMaxAttrs), `${id}-${defaultValueKey}`)
      })
    }));
  } // Button List


  if (layout === 'radioButtons') {
    return /*#__PURE__*/_jsx(Label, _objectSpread(_objectSpread(_objectSpread({
      text: heading,
      headingOnly: true,
      className: styles.formField
    }, labelDataset && {
      dataset: labelDataset
    }), tooltip && {
      icon: /*#__PURE__*/_jsx(TooltipIcon, {
        tooltip: tooltip
      })
    }), {}, {
      children: options.length ? /*#__PURE__*/_jsx(RadioButtons, {
        children: options.map(option => /*#__PURE__*/_jsx(RadioButtonsItem, {
          name: name || id,
          value: option.value,
          size: "small",
          checked: hasConfiguredDefaultValue && !isDirty ? defaultValue === option.value : value === option.value,
          onChange: evt => {
            onChangeValue(evt.target.value);
          },
          required: isRequired,
          disabled: Boolean(disabled),
          children: option.content
        }, `${id}-options-${isRequired}-${option.content}-${option.value}`))
      }) : /*#__PURE__*/_jsx(_Fragment, {})
    }));
  } // Generic Radio Inputs


  if (layout === 'radio') {
    return /*#__PURE__*/_jsx(Label, _objectSpread(_objectSpread(_objectSpread({
      text: heading,
      headingOnly: true,
      className: styles.formField
    }, labelDataset && {
      dataset: labelDataset
    }), tooltip && {
      icon: /*#__PURE__*/_jsx(TooltipIcon, {
        tooltip: tooltip
      })
    }), {}, {
      children: options.length ? options.map(option => /*#__PURE__*/_jsx(Radio, {
        name: name || id,
        value: option.value,
        checked: hasConfiguredDefaultValue && !isDirty ? defaultValue === option.value : value === option.value,
        disabled: Boolean(disabled),
        onChange: evt => {
          onChangeValue(evt.target.value);
        },
        children: option.content
      }, `${id}-options-${option.value}`)) : /*#__PURE__*/_jsx(_Fragment, {})
    }));
  } // System / hidden input
  // NOTE: ignore hidden input without value


  if (layout === 'hidden' && typeof srcDefaultValue !== 'undefined') {
    return /*#__PURE__*/_jsx("input", {
      id: id,
      ref: formInput,
      type: "hidden",
      name: name || id,
      value: `${defaultValue}`
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {});
};

export default Question;

const TooltipIcon = _ref2 => {
  let {
    tooltip
  } = _ref2;

  if (tooltip) {
    return /*#__PURE__*/_jsx(Tooltip, {
      placement: "bottom",
      content: tooltip,
      children: /*#__PURE__*/_jsx(InfoIcon, {})
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {});
};